import {LqdCarouselHandler} from './lqd-carousel';

class LqdServicesSlideshowHandler extends LqdCarouselHandler {

}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdServicesSlideshowHandler, { $element } );
}; 